export default {"src":"https://fishbrain.com/_next/static/media/vermont.f3b42022.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};